export default {"src":"/_next/static/media/multiple-choice-mini.0f5689c1.svg","height":22,"width":22};